import {
  deleteRequestV2,
  getRequestV2,
  patchRequestV2,
  postRequestV2,
} from '../../methods';
import { getSearchKpisEndpoint } from './utils';
// v2/kpis?kind=org|team&cycle_id
//
const getKpis = (type, typeId, cycleId, periodType) => {
  const periodTypeParam = `&period_type=${periodType}`;
  const cycleQuery = cycleId ? `&cycleId=${cycleId}` : '';
  let typeParam = '';

  if (type === 'team') {
    typeParam = `&team_id=${typeId}`;
  }

  if (type === 'business_unit') {
    typeParam = `&business_unit_id=${typeId}`;
  }

  return getRequestV2(
    `kpis?kind=${type}${typeParam}${periodTypeParam}${cycleQuery}`
  );
};

const getBusinessUnitKpis = businessUnitId =>
  getRequestV2(`bu/${businessUnitId}/kpis`);

const getKpi = (kpiId, periodType) => {
  let url = `kpis/${kpiId}`;

  if (periodType) {
    url += `?period_type=${periodType}`;
  }

  return getRequestV2(url);
};

const getKpiValues = (kpiId, periodType) =>
  getRequestV2(`kpis/${kpiId}/values?period_type=${periodType}`);

const createKpi = payload => postRequestV2(`kpis`, payload);

const editKpi = (kpiId, payload) => patchRequestV2(`kpis/${kpiId}`, payload);

const deleteKpi = kpiId => deleteRequestV2(`kpis/${kpiId}`);

// used to search all KPIs based on a query and/or team
const getSearchKpis = (kind, teamId, query) =>
  getRequestV2(getSearchKpisEndpoint(kind, teamId, query));

const upsertKpiValues = (kpiId, payload) =>
  postRequestV2(`kpis/${kpiId}/values`, payload);

const getKpiStatusLabels = () => getRequestV2(`kpi/status_labels`);

const getKpiPeriodTypes = () => getRequestV2(`kpi/period_types`);

const kpis = {
  getKpi,
  getKpiValues,
  getKpis,
  createKpi,
  editKpi,
  deleteKpi,
  getSearchKpis,
  getBusinessUnitKpis,
  upsertKpiValues,
  getKpiStatusLabels,
  getKpiPeriodTypes,
};

export default kpis;
